export {
  type AppGraphemeMeaningCardAlias,
  appGraphemeMeaningCardAliasTable,
} from "#app-grapheme-meaning-card-alias-table";
